/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Txn } from '@src/app/model/txn';

@Injectable({
    providedIn: 'root'
})
export class BankInterestService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    /*
        Only Used to post entries
    */

    protected get baseUrl(): string {
        return this.getAjaxPath('bank-accounts/interest');
    }
    protected cache: Txn[];
    protected typeString = 'addInterest';

}
